











import { Component, Vue, Prop } from "vue-property-decorator";
import { ITicket } from "@/models/tickets";

@Component({
  components: {
    "ticket-provider": () =>
      import("@/components/app/global/tickets/ticketProvider.vue"),
    "ticket-header": () =>
      import("@/components/app/global/tickets/ticketHeader.vue"),
    "ticket-feed": () =>
      import("@/components/app/global/tickets/ticketFeed.vue")
  }
})
export default class ClientTicketView extends Vue {
  @Prop({ required: true })
  public ticketId!: ITicket["id"];
}
